import { getCurrentInstance, watch, onUnmounted } from 'vue';
import { useQuery, useMutation } from '@vue/apollo-composable';
import { configureUiThemeProfile } from './useUiTheme';
import query from '@/graphql/user/userUiTheme.query.gql';
import mutation from '@/graphql/user/setCurrentUserUiTheme.mutation.gql';
import { i18n } from '@/plugins/i18n';

export function useUiThemeProfile() {
  const instance = getCurrentInstance();
  const { result } = useQuery(query, null, { fetchPolicy: 'network-only' });
  const { mutate } = useMutation(mutation);
  let stopped = false;
  onUnmounted(() => {
    stopped = true;
    configureUiThemeProfile(null);
  });
  watch(
    result,
    (value) => {
      const profile = value?.userSettings;
      if (!profile?.userId) return;
      configureUiThemeProfile(profile.userId, profile.uiTheme, async (theme) => {
        if (stopped) return;
        try {
          const response = await mutate({ theme });
          if (!response?.data?.setCurrentUserUiTheme) throw new Error('Theme was not saved');
        } catch {
          instance.proxy.$bvToast.toast(i18n.t('toast.failSaved'), { variant: 'danger' });
        }
      });
    },
    { immediate: true },
  );
}
